import { render, staticRenderFns } from "./commodityModal.vue?vue&type=template&id=56bd2338&"
import script from "./commodityModal.vue?vue&type=script&lang=js&"
export * from "./commodityModal.vue?vue&type=script&lang=js&"
import style0 from "./commodityModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports